import { useMemo } from 'react';
import { QuoteRequirementSection } from '~/lib/types/basket-types';
import RequirementField, { RequirementFieldProps } from './form-field-with-requirement';

export type RequirementsFieldProps = {
  name: string;
  requirements: QuoteRequirementSection;
} & RequirementFieldProps;

function RequirementsField(props: RequirementsFieldProps) {
  const { name, requirements } = props;
  const requirement = useMemo(() => requirements?.rules?.find((r) => r.key === name), [name, requirements?.rules]);
  return <RequirementField requirement={requirement} {...props} />;
}
export default RequirementsField;
